module.exports = __webpack_public_path__ + "static/img/CRAIG_MCDERMOTT.1659082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CRAIG_MCDERMOTT.jpg
// module id = k38T
// module chunks = 0